import { c as _c } from "react/compiler-runtime";
export default function ResultGlow() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden={true} className="pointer-events-none absolute inset-0 z-0 overflow-hidden"><div className="confirm-result-glow confirm-success-glow absolute inset-0" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}